import { createLogger as logger } from 'redux-logger';
import { routerMiddleware } from 'connected-react-router';

export default {
  routerMiddleware,
  logger,
};
